exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2e61d7e7] .vc-container{border:none}", ""]);

// exports
